var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { SaveButton, SimpleForm, useNotify, useRefresh, BooleanInput, useGetList, } from "react-admin";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { PageHeaderStyles } from "../../components/styles/PageHeaderStyles";
import { useTranslation } from "react-i18next";
import { useAtomValue } from "jotai";
import cssInputLookAndFeel from "@/atoms/css-input-look-and-feel";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { FormControl, FormControlLabel, Checkbox, FormGroup, FormLabel, Box, Autocomplete, Grid, TextField, } from "@mui/material";
import { SecretAttributeInput } from "./SecretAttributeInput";
import { useSecretRevealGuard } from "./useSecretRevealGuard";
import { ElectionHeaderStyles } from "@/components/styles/ElectionHeaderStyles";
import { EDIT_USER } from "@/queries/EditUser";
import { LIST_USER_ROLES } from "@/queries/ListUserRoles";
import { DataGrid } from "@mui/x-data-grid";
import { isUndefined } from "@sequentech/ui-core";
import { DELETE_USER_ROLE } from "@/queries/DeleteUserRole";
import { SET_USER_ROLE } from "@/queries/SetUserRole";
import { FormStyles } from "@/components/styles/FormStyles";
import { CREATE_USER } from "@/queries/CreateUser";
import { formatUserAtributes, getAttributeLabel, getAttributeLengthBounds, getAttributeViolation, getInputOptionLabels, getSelectOptionLabel, getStatedLengthBounds, getTranslationLabel, isSecretAttribute, resolveOptionLabel, userBasicInfo, } from "@/services/UserService";
import PhoneInput from "@/components/PhoneInput";
import SelectArea from "@/components/area/SelectArea";
import SelectActedTrustee from "./SelectActedTrustee";
import { AuthContext } from "@/providers/AuthContextProvider";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
import { InputContainerStyle, InputLabelStyle, PasswordInputStyle } from "./EditPassword";
import IconTooltip from "@/components/IconTooltip";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useUsersPermissions } from "./useUsersPermissions";
import { canEditVoterField } from "./voterFieldAccess";
import { CustomAutocompleteArrayInput, ReviewChangesTable } from "@sequentech/ui-essentials";
import { getSaveUserErrorMessage } from "./saveUserError";
import { SUPPORT_MATERIALS_ACKNOWLEDGED, VOTED_CHANNEL } from "./ListUsers";
import { WizardStyles } from "@/components/styles/WizardStyles";
import { computeRoleDiff, computeUserDiff } from "@/services/UserEditReviewChanges";
import { getVoterInputType, groupVoterAttributes, VoterAttributeGroups, VoterEditorRoot, VoterField, VOTER_EDITOR_FIXED_FIELDS, } from "./VoterEditorLayout";
import { REVEAL_VOTER_SECRET_ATTRIBUTE } from "@/queries/RevealVoterSecretAttribute";
var getAttributeStringValue = function (value) {
    var _a;
    if (Array.isArray(value)) {
        return (_a = value[0]) !== null && _a !== void 0 ? _a : "";
    }
    return value !== null && value !== void 0 ? value : "";
};
// Uncontrolled by design: the DOM owns the value while the user types, so a
// re-render triggered by anything else can never fight the input over its
// current text. The parent's attribute value is only read on mount (via
// defaultValue/key) and only written back on blur.
var AttributeTextInput = function (_a) {
    var disabled = _a.disabled, error = _a.error, helperText = _a.helperText, label = _a.label, maxLength = _a.maxLength, onCommit = _a.onCommit, onValidate = _a.onValidate, required = _a.required, value = _a.value, type = _a.type;
    var normalizedValue = getAttributeStringValue(value);
    var commit = function (current) {
        onValidate === null || onValidate === void 0 ? void 0 : onValidate(current);
        if (current !== normalizedValue) {
            onCommit(current);
        }
    };
    return (_jsx(FormStyles.TextField, { type: type, label: label, defaultValue: normalizedValue, onBlur: function (event) { return commit(event.target.value); }, disabled: disabled, error: error, helperText: helperText, required: required, fullWidth: true, slotProps: {
            htmlInput: {
                maxLength: maxLength,
                // This field only writes back on blur, and submitting the
                // form with Enter does not blur it, so the value being
                // typed would be dropped and never checked. Bound here
                // rather than on the TextField, which would put it on the
                // wrapper instead of the input. Committing a changed value
                // remounts this input, which drops focus, the same as
                // leaving the field would.
                onKeyDown: function (event) {
                    if (event.key !== "Enter") {
                        return;
                    }
                    event.preventDefault();
                    // A half-entered date reads as empty, and committing
                    // that would clear the stored one. Clearing a date is
                    // still done by emptying the field and leaving it.
                    if (type === "date" && event.currentTarget.value === "") {
                        return;
                    }
                    commit(event.currentTarget.value);
                },
            },
        }, InputLabelProps: type === "date" ? { shrink: true } : undefined }, normalizedValue));
};
var isFieldRequired = function (config) {
    var _a;
    // Keycloak controls requiredness. Username remains required by Step, while
    // email keeps its existing optional behavior.
    return Boolean((((_a = config === null || config === void 0 ? void 0 : config.required) === null || _a === void 0 ? void 0 : _a.roles) || (config === null || config === void 0 ? void 0 : config.name) === "username") && (config === null || config === void 0 ? void 0 : config.name) !== "email");
};
export var ListUserRoles = function (_a) {
    var _b;
    var userRoles = _a.userRoles, rolesList = _a.rolesList, activeRoleIds = _a.activeRoleIds, onToggleRole = _a.onToggleRole;
    var effectiveActiveRoleIds = (_b = activeRoleIds !== null && activeRoleIds !== void 0 ? activeRoleIds : userRoles === null || userRoles === void 0 ? void 0 : userRoles.list_user_roles.map(function (role) { return role.id || ""; })) !== null && _b !== void 0 ? _b : [];
    var rows = rolesList.map(function (role) { return (__assign(__assign({}, role), { id: role.id || "", active: effectiveActiveRoleIds.includes(role.id || "") || false })); });
    var editRolePermission = function (props) { return function () { return __awaiter(void 0, void 0, void 0, function () {
        var role;
        return __generator(this, function (_a) {
            role = (rolesList || []).find(function (el) { return el.id === props.row.id; });
            if (!(role === null || role === void 0 ? void 0 : role.id)) {
                return [2 /*return*/];
            }
            onToggleRole === null || onToggleRole === void 0 ? void 0 : onToggleRole(role.id);
            return [2 /*return*/];
        });
    }); }; };
    var columns = [
        {
            field: "name",
            headerName: "Role",
            width: 250,
            editable: false,
        },
        {
            field: "active",
            headerName: "Active",
            editable: false,
            renderCell: function (props) { return (_jsx(Checkbox, { checked: props.value, onClick: editRolePermission(props) })); },
        },
    ];
    return (_jsx(_Fragment, { children: _jsx(DataGrid, { rows: rows, columns: columns, initialState: {
                pagination: {
                    paginationModel: {
                        pageSize: 10,
                    },
                },
            }, pageSizeOptions: [10, 20, 50, 100], style: { width: "100%" } }) }));
};
var convertRecordToUser = function (record) {
    var user = {
        id: record.id ? String(record.id) : undefined,
        attributes: record.attributes || {},
        email: record.email,
        email_verified: record.email_verified,
        enabled: record.enabled,
        first_name: record.first_name,
        last_name: record.last_name,
        username: record.username,
        area: record.area,
        votes_info: record.votes_info || [],
    };
    return user;
};
export var EditUserForm = function (_a) {
    var _b, _c, _d;
    var id = _a.id, close = _a.close, electionEventId = _a.electionEventId, electionId = _a.electionId, rolesList = _a.rolesList, userAttributes = _a.userAttributes, userAttributeGroups = _a.userAttributeGroups, _e = _a.createMode, createMode = _e === void 0 ? false : _e, record = _a.record, onTaskLaunched = _a.onTaskLaunched;
    var t = useTranslation().t;
    var voterEditorCss = useAtomValue(cssInputLookAndFeel);
    var reviewI18nContext = electionEventId ? "voters" : "users";
    var _f = useState(createMode
        ? {
            enabled: true,
            attributes: {}, // Initialize attributes object for new users
        }
        : (record && convertRecordToUser(record)) || { attributes: {} }), user = _f[0], setUser = _f[1];
    var _g = useState(""), selectedArea = _g[0], setSelectedArea = _g[1];
    var _h = useState(""), selectedActedTrustee = _h[0], setSelectedActedTrustee = _h[1];
    var _j = useState([]), selectedRolesOnCreate = _j[0], setSelectedRolesOnCreate = _j[1];
    var _k = useState([]), selectedRoleIds = _k[0], setSelectedRoleIds = _k[1];
    var _l = useState({}), phoneInputs = _l[0], setPhoneInputs = _l[1];
    var _m = useUsersPermissions(), canEditVoters = _m.canEditVoters, canEditVotersWhoVoted = _m.canEditVotersWhoVoted, canEditVotersEmailTlf = _m.canEditVotersEmailTlf, canReadVoterSecretAttributes = _m.canReadVoterSecretAttributes, canWriteVoterSecretAttributes = _m.canWriteVoterSecretAttributes, canWritePermissionLabels = _m.canWritePermissionLabels;
    var tenantId = useTenantStore()[0];
    var refresh = useRefresh();
    var notify = useNotify();
    var authContext = useContext(AuthContext);
    var createUser = useMutation(CREATE_USER)[0];
    var edit_user = useMutation(EDIT_USER)[0];
    var revealSecretAttribute = useLazyQuery(REVEAL_VOTER_SECRET_ATTRIBUTE, { fetchPolicy: "no-cache" })[0];
    var deleteUserRole = useMutation(DELETE_USER_ROLE)[0];
    var setUserRole = useMutation(SET_USER_ROLE)[0];
    var _o = useState(((_b = user === null || user === void 0 ? void 0 : user.attributes) === null || _b === void 0 ? void 0 : _b.permission_labels) || []), permissionLabels = _o[0], setPermissionLabels = _o[1];
    var _p = useState(true), temporary = _p[0], setTemportay = _p[1];
    var _q = useState(((_d = (_c = user === null || user === void 0 ? void 0 : user.attributes) === null || _c === void 0 ? void 0 : _c.permission_labels) === null || _d === void 0 ? void 0 : _d.map(function (label) { return ({
        id: label,
        name: label,
    }); })) || []), choices = _q[0], setChoices = _q[1];
    var _r = useState(""), errorText = _r[0], setErrorText = _r[1];
    var _s = useState(""), saveError = _s[0], setSaveError = _s[1];
    var _t = useState(false), saving = _t[0], setSaving = _t[1];
    var _u = useState({}), lengthErrors = _u[0], setLengthErrors = _u[1];
    var _v = useState({}), secretAttributeValues = _v[0], setSecretAttributeValues = _v[1];
    var _w = useState(new Set()), dirtySecretAttributes = _w[0], setDirtySecretAttributes = _w[1];
    var _x = useState(new Set()), revealedSecretAttributes = _x[0], setRevealedSecretAttributes = _x[1];
    var _y = useState(new Set()), revealingSecretAttributes = _y[0], setRevealingSecretAttributes = _y[1];
    // Guarded through a ref as well as state: two clicks dispatched before
    // React commits the first would both read the same stale state.
    var savingRef = useRef(false);
    var revealingSecretAttributesRef = useRef(new Set());
    var closedRef = useRef(false);
    var beginSecretReveal = useSecretRevealGuard(JSON.stringify([tenantId, electionEventId, id]), canReadVoterSecretAttributes);
    var _z = useState("edit"), step = _z[0], setStep = _z[1];
    var baselineRef = useRef({
        user: createMode
            ? { enabled: true, attributes: {} }
            : (record && convertRecordToUser(record)) || { attributes: {} },
        phoneInputs: {},
    });
    var baselineRoleIdsRef = useRef([]);
    var rolesInitializedRef = useRef(false);
    var reviewHeadingRef = useRef(null);
    // Derived (not snapshotted) so the review table always reflects the live
    // user/phoneInputs/selectedActedTrustee state that handleConfirmChanges
    // actually submits, even if a debounced field update lands after Save.
    var reviewRows = useMemo(function () {
        if (step !== "review") {
            return [];
        }
        var secretAttributeChanges = Object.fromEntries(Array.from(dirtySecretAttributes).map(function (name) {
            var _a;
            return [
                name,
                ((_a = secretAttributeValues[name]) !== null && _a !== void 0 ? _a : []).filter(function (value) { return value !== ""; }),
            ];
        }));
        var userRows = computeUserDiff(baselineRef.current, { user: user, phoneInputs: phoneInputs, selectedActedTrustee: selectedActedTrustee, secretAttributeChanges: secretAttributeChanges }, userAttributes, t);
        var roleRows = computeRoleDiff({ activeRoleIds: baselineRoleIdsRef.current }, { activeRoleIds: selectedRoleIds }, rolesList, t);
        return __spreadArray(__spreadArray([], userRows, true), roleRows, true);
    }, [
        step,
        user,
        phoneInputs,
        selectedActedTrustee,
        userAttributes,
        selectedRoleIds,
        rolesList,
        t,
        dirtySecretAttributes,
        secretAttributeValues,
    ]);
    useEffect(function () {
        if (!id) {
            return;
        }
        setStep("edit");
        setSaveError("");
        setLengthErrors({});
        setSecretAttributeValues({});
        setDirtySecretAttributes(new Set());
        setRevealedSecretAttributes(new Set());
        revealingSecretAttributesRef.current.clear();
        setRevealingSecretAttributes(new Set());
        savingRef.current = false;
        closedRef.current = false;
        setSaving(false);
    }, [id]);
    useEffect(function () {
        if (canReadVoterSecretAttributes) {
            return;
        }
        revealingSecretAttributesRef.current.clear();
        setRevealingSecretAttributes(new Set());
        setRevealedSecretAttributes(new Set());
        setSecretAttributeValues(function (previous) {
            return Object.fromEntries(Object.entries(previous).filter(function (_a) {
                var name = _a[0];
                return dirtySecretAttributes.has(name);
            }));
        });
    }, [canReadVoterSecretAttributes, dirtySecretAttributes]);
    useEffect(function () {
        rolesInitializedRef.current = false;
        baselineRoleIdsRef.current = [];
        setSelectedRoleIds([]);
    }, [id]);
    useEffect(function () {
        if (step === "review" && reviewHeadingRef.current) {
            reviewHeadingRef.current.focus();
        }
    }, [step]);
    var equalToPassword = function (allValues) {
        if (!allValues.password || allValues.password.length == 0) {
            return;
        }
        if (allValues.confirm_password !== allValues.password) {
            setErrorText(t("usersAndRolesScreen.users.fields.passwordMismatch"));
        }
        if (errorText && allValues.confirm_password === allValues.password) {
            setErrorText("");
        }
    };
    useEffect(function () {
        var _a;
        var userPermissionLabels = (_a = user === null || user === void 0 ? void 0 : user.attributes) === null || _a === void 0 ? void 0 : _a.permission_labels;
        if (userPermissionLabels === null || userPermissionLabels === void 0 ? void 0 : userPermissionLabels.length) {
            setPermissionLabels(__spreadArray([], userPermissionLabels, true));
            var transformedChoices = userPermissionLabels === null || userPermissionLabels === void 0 ? void 0 : userPermissionLabels.map(function (label) { return ({
                id: label,
                name: label,
            }); });
            setChoices(__spreadArray([], transformedChoices, true));
        }
    }, [user]);
    var _0 = useQuery(LIST_USER_ROLES, {
        variables: {
            tenantId: tenantId,
            userId: id,
            electionEventId: electionEventId,
        },
        skip: !id || !tenantId,
    }), userRoles = _0.data, refetch = _0.refetch;
    useEffect(function () {
        if (createMode || rolesInitializedRef.current || !userRoles) {
            return;
        }
        var initialRoleIds = userRoles.list_user_roles.map(function (role) { return role.id || ""; });
        baselineRoleIdsRef.current = initialRoleIds;
        setSelectedRoleIds(initialRoleIds);
        rolesInitializedRef.current = true;
    }, [createMode, userRoles]);
    var voterCastVotes = useGetList("sequent_backend_cast_vote", {
        pagination: { page: 1, perPage: 10 },
        sort: { field: "last_updated_at", order: "DESC" },
        filter: {
            tenant_id: tenantId,
            election_event_id: electionEventId,
            voter_id_string: id,
        },
    }, {
        enabled: !!electionEventId,
    }).data;
    var electionsList = useGetList("sequent_backend_election", {
        pagination: { page: 1, perPage: 300 },
        sort: { field: "name", order: "DESC" },
        filter: {
            tenant_id: tenantId,
            election_event_id: electionEventId,
        },
    }, {
        enabled: !!electionEventId,
    }).data;
    var hasVoted = useMemo(function () {
        return voterCastVotes ? (voterCastVotes === null || voterCastVotes === void 0 ? void 0 : voterCastVotes.length) > 0 : false;
    }, [voterCastVotes]);
    // Mirrors harvest's edit_user: voter-voted-edit only lifts the "already
    // voted" lock, and without voter-write only email and mobile can change.
    var canEditField = useCallback(function (field) {
        var access = {
            createMode: Boolean(createMode),
            electionEventId: electionEventId,
            hasVoted: hasVoted,
            canEditVoters: canEditVoters,
            canEditVotersEmailTlf: canEditVotersEmailTlf,
            canEditVotersWhoVoted: canEditVotersWhoVoted,
        };
        return canEditVoterField(access, field);
    }, [
        createMode,
        electionEventId,
        hasVoted,
        canEditVoters,
        canEditVotersEmailTlf,
        canEditVotersWhoVoted,
    ]);
    var handleSelectedRolesOnCreate = useCallback(function (id) {
        var existId = selectedRolesOnCreate.find(function (roleId) { return id === roleId; });
        if (existId) {
            setSelectedRolesOnCreate(function (prev) { return prev.filter(function (roleId) { return id !== roleId; }); });
        }
        else {
            setSelectedRolesOnCreate(function (prev) { return __spreadArray(__spreadArray([], prev, true), [id], false); });
        }
    }, [setSelectedRolesOnCreate, selectedRolesOnCreate]);
    var handleSelectedRoles = useCallback(function (roleId) {
        setSelectedRoleIds(function (prev) {
            return prev.includes(roleId) ? prev.filter(function (id) { return id !== roleId; }) : __spreadArray(__spreadArray([], prev, true), [roleId], false);
        });
    }, []);
    // Counted over the attributes actually on the form: an error left against
    // one that is no longer shown could never be cleared, and would hold the
    // save for good.
    var hasFieldErrors = userAttributes.some(function (attr) { return attr.name && lengthErrors[attr.name]; });
    var beginSave = function () {
        if (savingRef.current) {
            return false;
        }
        savingRef.current = true;
        setSaving(true);
        setSaveError("");
        return true;
    };
    var endSave = function () {
        // A form that has asked to close is still mounted and clickable for as
        // long as the drawer animates out, so it stays latched rather than
        // re-arming its buttons for that window. The latch does not outlive the
        // drawer: it is a temporary one, so closing it unmounts this form and
        // the next one starts from fresh refs.
        if (closedRef.current) {
            return;
        }
        savingRef.current = false;
        setSaving(false);
    };
    // Latched only once the caller has taken over, so a form with nothing to
    // close, or whose caller throws, re-arms instead of going quietly dead.
    var closeForm = function () {
        if (!close) {
            return;
        }
        close();
        closedRef.current = true;
    };
    // Stated under the field so the bound is known before it is broken.
    var lengthHint = function (attr) {
        var bounds = getStatedLengthBounds(getAttributeLengthBounds(attr));
        if (!bounds) {
            return undefined;
        }
        if (bounds.min !== undefined && bounds.max !== undefined) {
            return t("usersAndRolesScreen.voters.errors.attribute.hintBetween", {
                min: bounds.min,
                max: bounds.max,
            });
        }
        return bounds.min !== undefined
            ? t("usersAndRolesScreen.voters.errors.attribute.hintMin", { min: bounds.min })
            : t("usersAndRolesScreen.voters.errors.attribute.hintMax", { max: bounds.max });
    };
    // What a field reports once it has been touched. Only touched fields are
    // checked, so opening a voter never lights up over data the admin has not
    // been near.
    var attributeError = function (attr, value) {
        var _a;
        var bounds = getAttributeLengthBounds(attr);
        var violation = getAttributeViolation(bounds, value, isFieldRequired(attr));
        if (!violation) {
            return undefined;
        }
        // The bounds the field states decide how this reads, so the two cannot
        // disagree over a bound the hint leaves unsaid; the numbers themselves
        // are the ones the value was measured against.
        var stated = (_a = getStatedLengthBounds(bounds)) !== null && _a !== void 0 ? _a : bounds;
        var field = getTranslationLabel(attr.name, attr.display_name, t);
        // Both bounds together read better as one sentence than as whichever
        // end the value happened to fall off.
        var messageKey = violation !== "required" && (stated === null || stated === void 0 ? void 0 : stated.min) !== undefined && (stated === null || stated === void 0 ? void 0 : stated.max) !== undefined
            ? "invalidLength"
            : violation;
        return t("usersAndRolesScreen.voters.errors.attribute.".concat(messageKey), {
            field: field,
            min: bounds === null || bounds === void 0 ? void 0 : bounds.min,
            max: bounds === null || bounds === void 0 ? void 0 : bounds.max,
        });
    };
    var validateAttribute = function (attr) { return function (value) {
        var name = attr.name;
        if (!name) {
            return;
        }
        var message = attributeError(attr, value);
        setLengthErrors(function (previous) {
            var _a;
            if (previous[name] === message) {
                return previous;
            }
            if (!message) {
                var _b = previous, _c = name, _removed = _b[_c], rest = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
                return rest;
            }
            return __assign(__assign({}, previous), (_a = {}, _a[name] = message, _a));
        });
    }; };
    var resolveFieldLabel = function (field) {
        var attribute = userAttributes.find(function (candidate) { return candidate.name === field; });
        // An attribute the form does not show, a hidden one for instance, has
        // no label to give, and the name is better than nothing to go on.
        return getTranslationLabel(field, attribute === null || attribute === void 0 ? void 0 : attribute.display_name, t) || field;
    };
    // The extracted reason is capped, so the raw rejection is logged for whoever
    // has to diagnose it. messageArgs carries the already translated message
    // through react-admin's polyglot provider, which would otherwise look it up
    // as a key and find nothing.
    var reportSaveError = function (error, messageKey, reasonKey) {
        console.error("Error saving voter:", error);
        var message = getSaveUserErrorMessage(error, messageKey, reasonKey, t, resolveFieldLabel);
        notify(message, { type: "error", messageArgs: { _: message } });
        return message;
    };
    var onSubmitCreateUser = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!beginSave()) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, createUserAndPassword()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    endSave();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var createUserAndPassword = function () { return __awaiter(void 0, void 0, void 0, function () {
        var createdUserId, secretNames, attributes_1, secretAttributes, data, error_1, error_2;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, , 3]);
                    secretNames = new Set(userAttributes
                        .filter(isSecretAttribute)
                        .flatMap(function (attribute) { return (attribute.name ? [attribute.name] : []); }));
                    attributes_1 = (_a = formatUserAtributes(user === null || user === void 0 ? void 0 : user.attributes)) !== null && _a !== void 0 ? _a : {};
                    secretNames.forEach(function (name) { return delete attributes_1[name]; });
                    secretAttributes = Object.fromEntries(Array.from(dirtySecretAttributes).map(function (name) {
                        var _a;
                        return [
                            name,
                            ((_a = secretAttributeValues[name]) !== null && _a !== void 0 ? _a : []).filter(function (value) { return value !== ""; }),
                        ];
                    }));
                    return [4 /*yield*/, createUser({
                            variables: {
                                tenantId: tenantId,
                                electionEventId: electionEventId,
                                user: {
                                    id: user === null || user === void 0 ? void 0 : user.id,
                                    first_name: user === null || user === void 0 ? void 0 : user.first_name,
                                    last_name: user === null || user === void 0 ? void 0 : user.last_name,
                                    enabled: user === null || user === void 0 ? void 0 : user.enabled,
                                    email: user === null || user === void 0 ? void 0 : user.email,
                                    username: user === null || user === void 0 ? void 0 : user.username,
                                    attributes: __assign(__assign(__assign(__assign({}, attributes_1), (selectedArea && { "area-id": [selectedArea] })), (phoneInputs && phoneInputs)), (selectedActedTrustee && { trustee: [selectedActedTrustee] })),
                                },
                                userRolesIds: selectedRolesOnCreate,
                                secretAttributes: secretAttributes,
                            },
                        })];
                case 1:
                    data = (_e.sent()).data;
                    createdUserId = (_b = data === null || data === void 0 ? void 0 : data.create_user) === null || _b === void 0 ? void 0 : _b.id;
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _e.sent();
                    setSaveError(reportSaveError(error_1, "usersAndRolesScreen.voters.errors.createError", "usersAndRolesScreen.voters.errors.createErrorReason"));
                    return [2 /*return*/];
                case 3:
                    _e.trys.push([3, 6, , 7]);
                    if (!(((_d = (_c = user === null || user === void 0 ? void 0 : user.password) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0 && createdUserId)) return [3 /*break*/, 5];
                    return [4 /*yield*/, handleUpdateUserPassword(createdUserId)];
                case 4:
                    _e.sent();
                    _e.label = 5;
                case 5:
                    notify(t("usersAndRolesScreen.voters.errors.createSuccess"), { type: "success" });
                    return [3 /*break*/, 7];
                case 6:
                    error_2 = _e.sent();
                    reportSaveError(error_2, "usersAndRolesScreen.voters.errors.createPasswordError", "usersAndRolesScreen.voters.errors.createPasswordErrorReason");
                    return [3 /*break*/, 7];
                case 7:
                    refresh();
                    closeForm();
                    return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var diff, roleDiff;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Reachable past the disabled button by submitting the form itself.
                    if (hasFieldErrors) {
                        return [2 /*return*/];
                    }
                    if (!createMode) return [3 /*break*/, 2];
                    return [4 /*yield*/, onSubmitCreateUser()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
                case 2:
                    setSaveError("");
                    diff = computeUserDiff(baselineRef.current, {
                        user: user,
                        phoneInputs: phoneInputs,
                        selectedActedTrustee: selectedActedTrustee,
                        secretAttributeChanges: Object.fromEntries(Array.from(dirtySecretAttributes).map(function (name) {
                            var _a;
                            return [
                                name,
                                ((_a = secretAttributeValues[name]) !== null && _a !== void 0 ? _a : []).filter(function (value) { return value !== ""; }),
                            ];
                        })),
                    }, userAttributes, t);
                    roleDiff = computeRoleDiff({ activeRoleIds: baselineRoleIdsRef.current }, { activeRoleIds: selectedRoleIds }, rolesList, t);
                    if (diff.length === 0 && roleDiff.length === 0) {
                        notify(t("usersAndRolesScreen.".concat(reviewI18nContext, ".review.noChanges")), {
                            type: "info",
                        });
                        return [2 /*return*/];
                    }
                    setStep("review");
                    return [2 /*return*/];
            }
        });
    }); };
    var handleUpdateUserPassword = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, edit_user({
                    variables: {
                        body: {
                            user_id: id,
                            tenant_id: tenantId,
                            election_event_id: electionEventId,
                            password: (user === null || user === void 0 ? void 0 : user.password) && (user === null || user === void 0 ? void 0 : user.password.length) > 0 ? user.password : undefined,
                            temporary: temporary,
                        },
                    },
                })];
        });
    }); };
    var handleEditUser = function () { return __awaiter(void 0, void 0, void 0, function () {
        var secretNames, attributes;
        var _a;
        return __generator(this, function (_b) {
            secretNames = new Set(userAttributes
                .filter(isSecretAttribute)
                .flatMap(function (attribute) { return (attribute.name ? [attribute.name] : []); }));
            attributes = (_a = formatUserAtributes(user === null || user === void 0 ? void 0 : user.attributes)) !== null && _a !== void 0 ? _a : {};
            secretNames.forEach(function (name) { return delete attributes[name]; });
            return [2 /*return*/, edit_user({
                    variables: {
                        body: {
                            user_id: user === null || user === void 0 ? void 0 : user.id,
                            tenant_id: tenantId,
                            election_event_id: electionEventId,
                            first_name: user === null || user === void 0 ? void 0 : user.first_name,
                            last_name: user === null || user === void 0 ? void 0 : user.last_name,
                            enabled: user === null || user === void 0 ? void 0 : user.enabled,
                            email: user === null || user === void 0 ? void 0 : user.email,
                            password: (user === null || user === void 0 ? void 0 : user.password) && (user === null || user === void 0 ? void 0 : user.password.length) > 0 ? user.password : undefined,
                            temporary: temporary,
                            attributes: __assign(__assign(__assign(__assign({}, attributes), (selectedArea && { "area-id": [selectedArea] })), (phoneInputs && phoneInputs)), (selectedActedTrustee && { trustee: [selectedActedTrustee] })),
                            secret_attributes: Object.fromEntries(Array.from(dirtySecretAttributes).map(function (name) {
                                var _a;
                                return [
                                    name,
                                    ((_a = secretAttributeValues[name]) !== null && _a !== void 0 ? _a : []).filter(function (value) { return value !== ""; }),
                                ];
                            })),
                        },
                    },
                })];
        });
    }); };
    var handleConfirmChanges = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, taskExecutionId, baselineRoleIds_1, rolesToRemove, rolesToAdd, _i, rolesToRemove_1, roleId, _a, rolesToAdd_1, roleId, error_3;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!beginSave()) {
                        return [2 /*return*/];
                    }
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 11, 12, 13]);
                    return [4 /*yield*/, handleEditUser()
                        // Datafix edits run as a task: surface it as soon as the edit is
                        // accepted, so ListUsers can still track an edit that is already
                        // running if a later step fails.
                    ];
                case 2:
                    result = _e.sent();
                    taskExecutionId = (_d = (_c = (_b = result === null || result === void 0 ? void 0 : result.data) === null || _b === void 0 ? void 0 : _b.edit_user) === null || _c === void 0 ? void 0 : _c.task_execution) === null || _d === void 0 ? void 0 : _d.id;
                    if (taskExecutionId) {
                        onTaskLaunched === null || onTaskLaunched === void 0 ? void 0 : onTaskLaunched(taskExecutionId);
                    }
                    baselineRoleIds_1 = baselineRoleIdsRef.current;
                    rolesToRemove = baselineRoleIds_1.filter(function (roleId) { return !selectedRoleIds.includes(roleId); });
                    rolesToAdd = selectedRoleIds.filter(function (roleId) { return !baselineRoleIds_1.includes(roleId); });
                    _i = 0, rolesToRemove_1 = rolesToRemove;
                    _e.label = 3;
                case 3:
                    if (!(_i < rolesToRemove_1.length)) return [3 /*break*/, 6];
                    roleId = rolesToRemove_1[_i];
                    return [4 /*yield*/, deleteUserRole({
                            variables: {
                                tenantId: tenantId,
                                roleId: roleId,
                                userId: user === null || user === void 0 ? void 0 : user.id,
                            },
                        })];
                case 4:
                    _e.sent();
                    _e.label = 5;
                case 5:
                    _i++;
                    return [3 /*break*/, 3];
                case 6:
                    _a = 0, rolesToAdd_1 = rolesToAdd;
                    _e.label = 7;
                case 7:
                    if (!(_a < rolesToAdd_1.length)) return [3 /*break*/, 10];
                    roleId = rolesToAdd_1[_a];
                    return [4 /*yield*/, setUserRole({
                            variables: {
                                tenantId: tenantId,
                                roleId: roleId,
                                userId: user === null || user === void 0 ? void 0 : user.id,
                            },
                        })];
                case 8:
                    _e.sent();
                    _e.label = 9;
                case 9:
                    _a++;
                    return [3 /*break*/, 7];
                case 10:
                    // Only moved once everything landed, so a retry after a failure
                    // re-applies the whole set. Keycloak joins and leaves a group
                    // idempotently, so re-applying what already landed is harmless.
                    baselineRoleIdsRef.current = selectedRoleIds;
                    if (authContext.userId === (user === null || user === void 0 ? void 0 : user.id)) {
                        authContext.updateTokenAndPermissionLabels();
                    }
                    // A launched task reports its own outcome in the widget, so a
                    // premature success toast would contradict it.
                    if (!taskExecutionId) {
                        notify(t("usersAndRolesScreen.voters.errors.editSuccess"), { type: "success" });
                    }
                    refresh();
                    closeForm();
                    return [3 /*break*/, 13];
                case 11:
                    error_3 = _e.sent();
                    // Whatever landed before the failure is already committed, so the
                    // list behind the drawer has to catch up either way.
                    refresh();
                    setSaveError(reportSaveError(error_3, "usersAndRolesScreen.voters.errors.editError", "usersAndRolesScreen.voters.errors.editErrorReason"));
                    return [3 /*break*/, 13];
                case 12:
                    endSave();
                    return [7 /*endfinally*/];
                case 13: return [2 /*return*/];
            }
        });
    }); };
    var handleBackToEdit = function () {
        setStep("edit");
        setSaveError("");
    };
    var handleChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, name, value, updatedUser;
        var _b;
        return __generator(this, function (_c) {
            _a = e.target, name = _a.name, value = _a.value;
            updatedUser = __assign(__assign({}, user), (_b = {}, _b[name] = value, _b));
            //only run on password update
            if (name === "confirm_password" || name === "password") {
                equalToPassword(updatedUser);
            }
            setUser(updatedUser);
            return [2 /*return*/];
        });
    }); };
    var handleDateChange = function (attrName) { return function (value) {
        setUser(function (prev) {
            var _a;
            var _b;
            return __assign(__assign({}, prev), { attributes: __assign(__assign({}, ((_b = prev === null || prev === void 0 ? void 0 : prev.attributes) !== null && _b !== void 0 ? _b : {})), (_a = {}, _a[attrName] = [value], _a)) });
        });
    }; };
    var handleSelectChange = function (attrName) { return function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setUser(function (prev) {
                var _a;
                return __assign(__assign({}, prev), { attributes: __assign(__assign({}, prev === null || prev === void 0 ? void 0 : prev.attributes), (_a = {}, _a[attrName] = [e], _a)) });
            });
            return [2 /*return*/];
        });
    }); }; };
    var handleArraySelectChange = function (value) {
        setUser(function (prev) {
            return __assign(__assign({}, prev), { attributes: __assign(__assign({}, prev === null || prev === void 0 ? void 0 : prev.attributes), { "authorized-election-ids": value }) });
        });
    };
    var handlePermissionLabelChanged = function (value) {
        setUser(function (prev) {
            return __assign(__assign({}, prev), { attributes: __assign(__assign({}, prev === null || prev === void 0 ? void 0 : prev.attributes), { permission_labels: value }) });
        });
    };
    var handleCheckboxChange = function (attrName) { return function (choiseId) {
        var checkedItems = [choiseId];
        if (user && (user === null || user === void 0 ? void 0 : user.attributes) && (user === null || user === void 0 ? void 0 : user.attributes[attrName])) {
            var currentChecked = user.attributes[attrName];
            checkedItems = currentChecked.includes(choiseId)
                ? currentChecked.filter(function (ab) { return ab !== choiseId; })
                : __spreadArray(__spreadArray([], currentChecked, true), [choiseId], false);
        }
        setUser(function (prev) {
            var _a;
            return __assign(__assign({}, prev), { attributes: __assign(__assign({}, prev === null || prev === void 0 ? void 0 : prev.attributes), (_a = {}, _a[attrName] = checkedItems, _a)) });
        });
    }; };
    var handlePhoneNumberChange = function (attrName) { return function (number) { return __awaiter(void 0, void 0, void 0, function () {
        var phoneInput;
        return __generator(this, function (_a) {
            phoneInput = phoneInputs[attrName];
            if (!phoneInput || (phoneInput && phoneInput[0] !== number)) {
                setPhoneInputs(function (prev) {
                    var _a;
                    return __assign(__assign({}, prev), (_a = {}, _a[attrName] = [number], _a));
                });
            }
            return [2 /*return*/];
        });
    }); }; };
    var commitSecretAttribute = function (attribute, values) {
        var name = attribute.name;
        if (!name)
            return;
        var message = (values.length ? values : [""])
            .map(function (value) { return attributeError(attribute, value); })
            .find(Boolean);
        setLengthErrors(function (previous) {
            var _a;
            var _b = previous, _c = name, _removed = _b[_c], rest = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
            return message ? __assign(__assign({}, rest), (_a = {}, _a[name] = message, _a)) : rest;
        });
        setSecretAttributeValues(function (previous) {
            var _a;
            return (__assign(__assign({}, previous), (_a = {}, _a[name] = values, _a)));
        });
        setDirtySecretAttributes(function (previous) { return new Set(previous).add(name); });
    };
    var toggleSecretAttributeReveal = function (name) { return __awaiter(void 0, void 0, void 0, function () {
        var isCurrent, data_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (revealedSecretAttributes.has(name)) {
                        setRevealedSecretAttributes(function (previous) {
                            var next = new Set(previous);
                            next.delete(name);
                            return next;
                        });
                        if (!dirtySecretAttributes.has(name)) {
                            setSecretAttributeValues(function (previous) {
                                var _a = previous, _b = name, _removed = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                                return rest;
                            });
                        }
                        return [2 /*return*/];
                    }
                    if (!!Object.prototype.hasOwnProperty.call(secretAttributeValues, name)) return [3 /*break*/, 5];
                    if (!tenantId || !electionEventId || !id)
                        return [2 /*return*/];
                    isCurrent = beginSecretReveal();
                    if (!isCurrent() || closedRef.current)
                        return [2 /*return*/];
                    if (revealingSecretAttributesRef.current.has(name))
                        return [2 /*return*/];
                    revealingSecretAttributesRef.current.add(name);
                    setRevealingSecretAttributes(function (previous) { return new Set(previous).add(name); });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, revealSecretAttribute({
                            variables: {
                                tenantId: tenantId,
                                electionEventId: electionEventId,
                                userId: id,
                                attributeName: name,
                            },
                        })];
                case 2:
                    data_1 = (_b.sent()).data;
                    if (!isCurrent() || closedRef.current)
                        return [2 /*return*/];
                    setSecretAttributeValues(function (previous) {
                        var _a;
                        var _b;
                        return (__assign(__assign({}, previous), (_a = {}, _a[name] = (_b = data_1 === null || data_1 === void 0 ? void 0 : data_1.reveal_voter_secret_attribute.values) !== null && _b !== void 0 ? _b : [], _a)));
                    });
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    if (!isCurrent() || closedRef.current)
                        return [2 /*return*/];
                    notify(t("usersAndRolesScreen.voters.secretAttribute.revealError"), {
                        type: "error",
                    });
                    return [2 /*return*/];
                case 4:
                    if (isCurrent() && !closedRef.current) {
                        revealingSecretAttributesRef.current.delete(name);
                        setRevealingSecretAttributes(function (previous) {
                            var next = new Set(previous);
                            next.delete(name);
                            return next;
                        });
                    }
                    return [7 /*endfinally*/];
                case 5:
                    setRevealedSecretAttributes(function (previous) { return new Set(previous).add(name); });
                    return [2 /*return*/];
            }
        });
    }); };
    var aliasRenderer = useAliasRenderer();
    var searched = useRef("");
    var electionFilterToQuery = function (searchText) {
        if (searchText && searchText.length > 0) {
            searched.current = searchText.trim();
        }
        return { "name@_ilike,alias@_ilike": searched.current };
    };
    var formattedElections = electionsList === null || electionsList === void 0 ? void 0 : electionsList.map(function (e) {
        var _a;
        return {
            external_id: (_a = e.external_id) !== null && _a !== void 0 ? _a : "",
            id: e.id,
            name: aliasRenderer(e),
        };
    });
    var renderFormInput = useCallback(function (attr, index) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        if (attr.name === VOTED_CHANNEL) {
            return;
        }
        if (attr.name === SUPPORT_MATERIALS_ACKNOWLEDGED) {
            return;
        }
        if (attr.name) {
            var isCustomAttribute = !userBasicInfo.includes(attr.name);
            var value_1 = isCustomAttribute
                ? (_a = user === null || user === void 0 ? void 0 : user.attributes) === null || _a === void 0 ? void 0 : _a[attr.name]
                : user && user[attr.name];
            var displayName_1 = (_b = attr.display_name) !== null && _b !== void 0 ? _b : "";
            var isRequired_1 = isFieldRequired(attr);
            var optionLabels_1 = getInputOptionLabels(attr);
            var fieldEditable_1 = canEditField(attr.name);
            if (isSecretAttribute(attr)) {
                var name_1 = attr.name;
                var stored = Boolean((_d = (_c = user === null || user === void 0 ? void 0 : user.attributes) === null || _c === void 0 ? void 0 : _c[name_1]) === null || _d === void 0 ? void 0 : _d.length);
                return (_jsx(SecretAttributeInput, { label: getTranslationLabel(name_1, attr.display_name, t), values: (_e = secretAttributeValues[name_1]) !== null && _e !== void 0 ? _e : [], stored: stored, editable: canWriteVoterSecretAttributes && fieldEditable_1 && !saving, multivalued: Boolean(attr.multivalued), canReveal: dirtySecretAttributes.has(name_1) ||
                        (stored && canReadVoterSecretAttributes), revealed: revealedSecretAttributes.has(name_1), revealing: revealingSecretAttributes.has(name_1) || saving, required: isRequired_1 && (createMode || !stored), error: !!lengthErrors[name_1], helperText: (_f = lengthErrors[name_1]) !== null && _f !== void 0 ? _f : lengthHint(attr), labels: {
                        reveal: t("usersAndRolesScreen.voters.secretAttribute.reveal"),
                        hide: t("usersAndRolesScreen.voters.secretAttribute.hide"),
                        clear: t("usersAndRolesScreen.voters.secretAttribute.clear"),
                        add: t("usersAndRolesScreen.voters.secretAttribute.add"),
                        remove: t("usersAndRolesScreen.voters.secretAttribute.remove"),
                    }, onChange: function (values) { return commitSecretAttribute(attr, values); }, onReveal: function () { return void toggleSecretAttributeReveal(name_1); } }, name_1));
            }
            if (((_g = attr.annotations) === null || _g === void 0 ? void 0 : _g.inputType) === "select") {
                var configuredOptions = (_j = (_h = attr.validations) === null || _h === void 0 ? void 0 : _h.options) === null || _j === void 0 ? void 0 : _j.options;
                var options = Array.isArray(configuredOptions)
                    ? configuredOptions.filter(function (option) { return typeof option === "string"; })
                    : [];
                var selectOptions = options.length > 0 ? __spreadArray([], options, true).sort() : ["-"];
                return (_jsx(Grid, { container: true, spacing: 2, children: _jsx(Grid, { size: 12, children: _jsx(FormControl, { fullWidth: true, children: _jsx(Autocomplete, { value: getAttributeStringValue(value_1) || null, onChange: function (event, newValue) {
                                    var fieldName = attr.name || "";
                                    var selectedValue = newValue || "";
                                    handleSelectChange(fieldName)(selectedValue);
                                }, options: selectOptions, getOptionLabel: function (option) {
                                    return getSelectOptionLabel(optionLabels_1, option, t);
                                }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { label: "".concat(getTranslationLabel(attr.name, attr.display_name, t), " ").concat(isRequired_1 ? "*" : ""), inputProps: __assign(__assign({}, params.inputProps), { required: isRequired_1, name: displayName_1 }), disabled: !fieldEditable_1, fullWidth: true, style: {
                                        display: "block",
                                        visibility: "visible",
                                    } }))); }, disabled: !fieldEditable_1 }) }) }) }, index));
            }
            else if (((_k = attr.annotations) === null || _k === void 0 ? void 0 : _k.inputType) === "multiselect-checkboxes") {
                var choices_1 = Object.entries(optionLabels_1 !== null && optionLabels_1 !== void 0 ? optionLabels_1 : {}).map(function (_a) {
                    var key = _a[0], value = _a[1];
                    return { id: key, name: resolveOptionLabel(value, t) };
                });
                if (choices_1.length === 0) {
                    return;
                }
                return (_jsxs(FormControl, { component: "fieldset", children: [_jsx(FormLabel, { component: "legend", style: { margin: 0 }, children: getTranslationLabel(attr.name, attr.display_name, t) }), _jsx(FormGroup, { row: true, children: choices_1.map(function (choice) {
                                return (_jsx(FormControlLabel, { control: _jsx(Checkbox, { disabled: !fieldEditable_1, checked: value_1 && value_1.includes(choice.id), onChange: function () {
                                            var _a;
                                            return handleCheckboxChange((_a = attr.name) !== null && _a !== void 0 ? _a : "")(choice.id);
                                        } }), label: choice.name }, choice.id));
                            }) })] }, index));
            }
            else if (((_l = attr.annotations) === null || _l === void 0 ? void 0 : _l.inputType) === "html5-date") {
                return (_jsx(AttributeTextInput, { type: "date", label: getTranslationLabel(attr.name, attr.display_name, t), value: value_1, onCommit: handleDateChange(attr.name), required: isRequired_1, disabled: !fieldEditable_1 }, (_m = attr.name) !== null && _m !== void 0 ? _m : index));
            }
            else if (attr.name.toLowerCase().includes("area")) {
                return;
            }
            else if (attr.name.toLowerCase().includes("mobile-number")) {
                return (_jsx(PhoneInput, { handlePhoneNumberChange: handlePhoneNumberChange(attr.name), label: getTranslationLabel(attr.name, attr.display_name, t), fullWidth: true, initialValue: value_1, disabled: !fieldEditable_1 }, index));
            }
            else if (attr.name.toLowerCase().includes("trustee")) {
                return (_jsx(FormControl, { fullWidth: true, children: _jsx(SelectActedTrustee, { label: String(t("usersAndRolesScreen.users.fields.trustee")), source: createMode ? "attributes.trustee" : "trustee", defaultValue: (_o = value_1 === null || value_1 === void 0 ? void 0 : value_1[0]) !== null && _o !== void 0 ? _o : "", tenantId: tenantId, onSelectTrustee: function (trustee) {
                            setSelectedActedTrustee(trustee);
                        } }) }, index));
            }
            else if (attr.name.toLowerCase().includes("authorized-election-ids")) {
                return (_jsx(_Fragment, { children: _jsx(FormStyles.AutocompleteArrayInput, { label: getTranslationLabel(attr.name, attr.display_name, t), className: "elections-selector", fullWidth: true, choices: formattedElections || [], source: "attributes.authorized-election-ids", optionValue: "external_id", optionText: "name", onChange: handleArraySelectChange, disabled: !fieldEditable_1 }, index) }));
            }
            else if (attr.name.toLowerCase().includes("permission_labels")) {
                return (_jsx(CustomAutocompleteArrayInput, { label: String(t("usersAndRolesScreen.users.fields.permissionLabel")), defaultValue: permissionLabels, onChange: handlePermissionLabelChanged, choices: choices, disabled: !fieldEditable_1 || (!electionEventId && !canWritePermissionLabels) }, index));
            }
            return (_jsx(_Fragment, { children: isCustomAttribute ? (_jsx(AttributeTextInput, { label: getTranslationLabel(attr.name, attr.display_name, t), error: !!lengthErrors[attr.name], helperText: (_p = lengthErrors[attr.name]) !== null && _p !== void 0 ? _p : lengthHint(attr), maxLength: (_q = getAttributeLengthBounds(attr)) === null || _q === void 0 ? void 0 : _q.max, onValidate: validateAttribute(attr), value: value_1, onCommit: function (newValue) {
                        var attrName = attr.name;
                        setUser(function (prev) {
                            var _a;
                            var _b;
                            return (__assign(__assign({}, prev), { attributes: __assign(__assign({}, ((_b = prev === null || prev === void 0 ? void 0 : prev.attributes) !== null && _b !== void 0 ? _b : {})), (_a = {}, _a[attrName] = [newValue], _a)) }));
                        });
                    }, required: isRequired_1, disabled: !fieldEditable_1 }, index)) : (_jsx(FormStyles.TextInput, { label: getTranslationLabel(attr.name, attr.display_name, t), onChange: handleChange, onBlur: function (event) { return validateAttribute(attr)(event.target.value); }, source: attr.name, helperText: (_r = lengthErrors[attr.name]) !== null && _r !== void 0 ? _r : lengthHint(attr), slotProps: {
                        htmlInput: {
                            "maxLength": (_s = getAttributeLengthBounds(attr)) === null || _s === void 0 ? void 0 : _s.max,
                            "aria-invalid": !!lengthErrors[attr.name],
                        },
                    }, sx: lengthErrors[attr.name]
                        ? {
                            "& .MuiFormHelperText-root": {
                                color: "error.main",
                            },
                            "& .MuiOutlinedInput-root fieldset": {
                                borderColor: "error.main",
                            },
                            "& .MuiInputLabel-root": { color: "error.main" },
                        }
                        : undefined, required: isFieldRequired(attr), disabled: (attr.name === "username" && !createMode) || !fieldEditable_1 }, attr.display_name)) }));
        }
    }, [
        user,
        permissionLabels,
        choices,
        electionsList,
        lengthErrors,
        secretAttributeValues,
        dirtySecretAttributes,
        revealedSecretAttributes,
        revealingSecretAttributes,
        saving,
        toggleSecretAttributeReveal,
        commitSecretAttribute,
        canReadVoterSecretAttributes,
        canWriteVoterSecretAttributes,
        canWritePermissionLabels,
        createMode,
        electionEventId,
        canEditField,
    ]);
    var visibleUserAttributes = useMemo(function () {
        return userAttributes.filter(function (attribute) {
            var _a;
            return Boolean(attribute.name) &&
                attribute.name !== VOTED_CHANNEL &&
                !((_a = attribute.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes("area"));
        });
    }, [userAttributes]);
    var attributeRuns = useMemo(function () { return groupVoterAttributes(visibleUserAttributes, userAttributeGroups); }, [visibleUserAttributes, userAttributeGroups]);
    var resolveGroupText = useCallback(function (value) {
        if (!value)
            return "";
        var translated = String(t(value));
        return translated === value ? getAttributeLabel(value) : translated;
    }, [t]);
    var renderFormField = useCallback(function (attribute, index) {
        if (!attribute.name)
            return null;
        var input = renderFormInput(attribute, index);
        if (!input)
            return null;
        return (_jsx(VoterField, { inputType: getVoterInputType(attribute), name: attribute.name, required: isFieldRequired(attribute), children: input }, attribute.name));
    }, [renderFormInput]);
    var formFields = (_jsx(VoterAttributeGroups, { runs: attributeRuns, renderField: renderFormField, getHeader: function (run) { var _a, _b; return resolveGroupText((_b = (_a = run.group) === null || _a === void 0 ? void 0 : _a.display_header) !== null && _b !== void 0 ? _b : run.name); }, getDescription: function (run) { var _a; return resolveGroupText((_a = run.group) === null || _a === void 0 ? void 0 : _a.display_description); } }));
    var alertMessage = saveError ||
        (hasFieldErrors ? t("usersAndRolesScreen.voters.errors.attribute.fieldsToCorrect") : "");
    var saveErrorAlert = alertMessage ? (_jsx(WizardStyles.ErrorMessage, { variant: "body2", role: "alert", className: "edit-voter-save-error", children: alertMessage })) : null;
    if (!user && !createMode) {
        return null;
    }
    // Update the area selection handler
    var handleAreaSelection = function (areaId, areaRecord) {
        setSelectedArea(areaId);
        if (createMode) {
            setUser(function (prev) { return (__assign(__assign({}, prev), { area: {
                    id: areaId,
                    name: areaRecord === null || areaRecord === void 0 ? void 0 : areaRecord.name,
                }, attributes: __assign(__assign({}, ((prev === null || prev === void 0 ? void 0 : prev.attributes) || {})), { "area-id": [areaId] }) })); });
        }
        else {
            setUser(function (prev) { return (__assign(__assign({}, prev), { area: {
                    id: areaId,
                    name: areaRecord === null || areaRecord === void 0 ? void 0 : areaRecord.name,
                }, attributes: __assign(__assign({}, ((prev === null || prev === void 0 ? void 0 : prev.attributes) || {})), { "area-id": [areaId] }) })); });
        }
    };
    return (_jsx(PageHeaderStyles.Wrapper, { children: _jsx(VoterEditorRoot, { customCss: voterEditorCss, mode: createMode ? "create" : "edit", children: _jsxs(SimpleForm, { toolbar: step === "edit" ? (_jsx(SaveButton, { alwaysEnable: !errorText && !saving && !hasFieldErrors, disabled: saving || hasFieldErrors })) : (false), record: user, onSubmit: onSubmit, sanitizeEmptyValues: true, children: [_jsx(PageHeaderStyles.Title, { children: t("usersAndRolesScreen.".concat(reviewI18nContext, ".title")) }), _jsx(PageHeaderStyles.SubTitle, { children: t("usersAndRolesScreen.".concat(reviewI18nContext, ".subtitle")) }), _jsxs(Box, { sx: {
                            display: step === "review" ? "none" : undefined,
                            minWidth: 0,
                            width: "100%",
                        }, children: [formFields, _jsx(VoterField, { name: "enabled", inputType: VOTER_EDITOR_FIXED_FIELDS.enabled, required: true, children: _jsx(FormStyles.CheckboxControlLabel, { label: "".concat(t("usersAndRolesScreen.users.fields.enabled"), " *"), control: _jsx(Checkbox, { disabled: !canEditField("enabled"), checked: (user === null || user === void 0 ? void 0 : user.enabled) || false, onChange: function (event) {
                                            setUser(__assign(__assign({}, user), { enabled: event.target.checked }));
                                        } }) }) }), electionEventId && (_jsx(VoterField, { name: "area", inputType: VOTER_EDITOR_FIXED_FIELDS.area, required: true, children: _jsxs(FormControl, { fullWidth: true, children: [_jsxs(ElectionHeaderStyles.Title, { children: [t("usersAndRolesScreen.users.fields.area"), " *"] }), _jsx(SelectArea, { tenantId: tenantId, electionEventId: electionEventId, source: createMode ? "attributes.area-id[0]" : "area.id", onSelectArea: handleAreaSelection, label: "", isRequired: true, disabled: !canEditField("area-id"), customStyle: {
                                                "& legend": {
                                                    display: "none",
                                                },
                                            } })] }) })), createMode && (_jsxs(_Fragment, { children: [_jsx(VoterField, { name: "password", inputType: VOTER_EDITOR_FIXED_FIELDS.password, required: false, children: _jsxs(FormControl, { fullWidth: true, children: [_jsxs(ElectionHeaderStyles.Title, { children: [t("usersAndRolesScreen.users.fields.password"), ":"] }), _jsx(PasswordInputStyle, { label: false, source: "password", onChange: handleChange, error: !!errorText, disabled: !canEditField("password") })] }) }), _jsx(VoterField, { name: "confirm_password", inputType: VOTER_EDITOR_FIXED_FIELDS.confirm_password, required: false, children: _jsxs(FormControl, { fullWidth: true, children: [_jsxs(ElectionHeaderStyles.Title, { children: [t("usersAndRolesScreen.users.fields.repeatPassword"), ":"] }), _jsx(PasswordInputStyle, { label: false, source: "confirm_password", onChange: handleChange, helperText: errorText, error: !!errorText, disabled: !canEditField("password") })] }) }), _jsx(VoterField, { name: "password_temporary", inputType: VOTER_EDITOR_FIXED_FIELDS.password_temporary, required: false, children: _jsxs(InputContainerStyle, { sx: { flexDirection: "row !important" }, children: [_jsx(InputLabelStyle, { paddingTop: false, children: _jsxs(Box, { sx: { display: "flex", gap: "8px" }, children: [t("usersAndRolesScreen.editPassword.temporatyLabel"), _jsx(IconTooltip, { icon: faInfoCircle, info: String(t("usersAndRolesScreen.editPassword.temporatyInfo")) })] }) }), _jsx(BooleanInput, { source: "", label: false, onChange: function (e) { return setTemportay(!temporary); }, checked: temporary, disabled: !canEditField("password") })] }) })] })), isUndefined(electionEventId) ? (_jsx(ListUserRoles, { userRoles: userRoles, rolesList: rolesList, activeRoleIds: createMode ? selectedRolesOnCreate : selectedRoleIds, onToggleRole: createMode ? handleSelectedRolesOnCreate : handleSelectedRoles })) : null, step === "edit" && saveErrorAlert] }), !createMode && step === "review" && (_jsxs(Box, { sx: { width: "100%" }, children: [_jsx(ReviewChangesTable, { title: t("usersAndRolesScreen.".concat(reviewI18nContext, ".review.title")), subtitle: t("usersAndRolesScreen.".concat(reviewI18nContext, ".review.subtitle")), fieldLabel: t("usersAndRolesScreen.".concat(reviewI18nContext, ".review.field")), currentValueLabel: t("usersAndRolesScreen.".concat(reviewI18nContext, ".review.currentValue")), newValueLabel: t("usersAndRolesScreen.".concat(reviewI18nContext, ".review.newValue")), rows: reviewRows, headingRef: reviewHeadingRef }), saveErrorAlert, _jsx(WizardStyles.FooterContainer, { children: _jsxs(WizardStyles.StyledFooter, { children: [_jsx(WizardStyles.BackButton, { type: "button", onClick: handleBackToEdit, disabled: saving, className: "edit-voter-review-edit-button", children: t("common.label.edit") }), _jsx(WizardStyles.NextButton, { type: "button", onClick: handleConfirmChanges, disabled: saving, className: "edit-voter-review-confirm-button", children: t("usersAndRolesScreen.".concat(reviewI18nContext, ".review.confirm")) })] }) })] }))] }) }) }));
};
